// Dev-mode mock for the state-wise Tax Report. Field names match what the real
// TaxReport endpoint is expected to return so swapping to live data is a no-op.
export let DemoTaxReportResponse: any = {
    "success": true,
    "message": "Request Completed Successfully",
    "responseStatusCode": 903,
    "data": [
        {
            "state": "Texas",
            "rate": 6.25,
            "taxableOrders": 5,
            "nonTaxableOrders": 1,
            "grossSales": 100.00,
            "taxCollected": 6.25,
            "refundedTax": 1.25,
            "netTax": 5.00
        },
        {
            "state": "California",
            "rate": 7.25,
            "taxableOrders": 3,
            "nonTaxableOrders": 0,
            "grossSales": 60.00,
            "taxCollected": 4.35,
            "refundedTax": 0.00,
            "netTax": 4.35
        }
    ],
    "code": "IMS0122903",
    "totalRecords": 2,
    "elapsedTime": "31002",
    "showThisMessage": false
}
